import React, { useState, useEffect } from "react";
import { Container, Row, Col, Breadcrumb, Form, Card } from "react-bootstrap";
import { Modal, Button, Spinner } from "react-bootstrap";
import $ from "jquery";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/Banner/apply-online.webp";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import Admissionform from "../../Images/PDF/ISBMUniversity-Admission Form.pdf";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ApplicationPdfModal from "./ApplicationPdfModal";
const ApplyOnline = () => {
  useEffect(() => {
    const schemas = [
      {
        id: "webpage-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": "https://isbmuniversity.edu.in/apply-online#webpage",
          url: "https://isbmuniversity.edu.in/apply-online",
          name: "Apply Online - Admissions Open Now | ISBM University Chhattisgarh",
          description:
            "Apply online for admission to ISBM University for UG, PG, diploma and Ph.D. programmes in Chhattisgarh. Submit your application today as seats are filling fast.",
          isPartOf: {
            "@type": "WebSite",
            "@id": "https://isbmuniversity.edu.in/#website",
            name: "ISBM University",
            url: "https://isbmuniversity.edu.in/",
          },
          inLanguage: "en-IN",
        },
      },

      {
        id: "college-or-university-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "CollegeOrUniversity",
          "@id": "https://isbmuniversity.edu.in/#collegeOrUniversity",
          name: "ISBM University | Best Private University in Chhattisgarh",
          url: "https://isbmuniversity.edu.in/",
          logo: "https://isbmuniversity.edu.in/static/media/isbm-university.9ceb30717bf3ba95be6a.webp",
          image:
            "https://isbmuniversity.edu.in/static/media/isbm-university.9ceb30717bf3ba95be6a.webp",
          description:
            "ISBM University is a private university in Chhattisgarh offering UG, PG, diploma and Ph.D. programs with industry focused education and career opportunities.",
          telephone: "+91-9373199999",
          email: "info@isbmuniversity.edu.in",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Nawapara (Kosmi), Block & Tehsil- Chhura",
            addressLocality: "Gariyaband",
            addressRegion: "Chhattisgarh",
            postalCode: "493996",
            addressCountry: "IN",
          },
          sameAs: [
            "https://www.facebook.com/isbmuniversity/",
            "https://www.instagram.com/isbm_university",
            "https://www.linkedin.com/school/13211303/admin/",
          ],
        },
      },

      {
        id: "local-business-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "ISBM University",
          image:
            "https://isbmuniversity.edu.in/static/media/isbm-university.9ceb30717bf3ba95be6a.webp",
          "@id": "https://isbmuniversity.edu.in/#organization",
          url: "https://isbmuniversity.edu.in/",
          telephone: "+91-9373199999",
          location: [
            {
              "@type": "Place",
              name: "ISBM University - Raipur Off-Campus",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Ring Road No. 1, Near Sarona Bridge, Tatibandh",
                addressLocality: "Raipur",
                addressRegion: "Chhattisgarh",
                postalCode: "492099",
                addressCountry: "IN",
              },
            },
            {
              "@type": "Place",
              name: "ISBM University - Main Campus",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Nawapara (Kosmi), Block & Tehsil - Chhura",
                addressLocality: "Gariyaband",
                addressRegion: "Chhattisgarh",
                postalCode: "493996",
                addressCountry: "IN",
              },
            },
          ],
        },
      },

      {
        id: "breadcrumb-schema",
        data: {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://isbmuniversity.edu.in/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Apply Online",
              item: "https://isbmuniversity.edu.in/apply-online",
            },
          ],
        },
      },
    ];

    const createdScripts = [];

    schemas.forEach(({ id, data }) => {
      const existingScript = document.head.querySelector(
        `script[data-schema-id="${id}"]`,
      );

      if (existingScript) {
        existingScript.remove();
      }

      const script = document.createElement("script");

      script.type = "application/ld+json";
      script.setAttribute("data-schema-id", id);
      script.textContent = JSON.stringify(data);

      document.head.appendChild(script);

      createdScripts.push(script);
    });

    return () => {
      createdScripts.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  const EMPTY_ROW = (examPassed) => ({
    examPassed,
    stream: "",
    institution: "",
    yearOfPassing: "",
    subjects: "",
    marksObtained: "",
    maxMarks: "",
    percentage: "",
  });

  const FIXED_EXAMS = [
    "10th",
    "12th",
    "Graduation",
    "Post Graduation",
    "Any Other Qualification",
  ];

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("data");

    if (encoded) {
      try {
        const decoded = decodeURIComponent(escape(atob(encoded)));
        console.log("Decoded:", decoded);

        const searchParams = new URLSearchParams(decoded);

        const counsellorParam = searchParams.get("counsellor");
        let counsellorName = "";
        if (counsellorParam) {
          counsellorName = counsellorParam.split("*").pop();
        }
        const zoneValue = searchParams.get("zone") || "NA";
        const leadIdValue = searchParams.get("leadId") || "NA";
        const branchValue = searchParams.get("branch") || "NA";

        setFormData((prev) => ({
          ...prev,
          fullName: searchParams.get("name") || prev.fullName,
          telephone: searchParams.get("mobile") || prev.telephone,
          email: searchParams.get("email") || prev.email,
          counselingCenter: searchParams.get("branch") || prev.counselingCenter,
          counselorName: counsellorName || prev.counselorName,
          zone: zoneValue,
          branch: branchValue,
          leadId: leadIdValue,
        }));

        document.getElementById("name1").value = searchParams.get("name") || "";
        document.getElementById("phone1").value =
          searchParams.get("mobile") || "";
        document.getElementById("email1").value =
          searchParams.get("email") || "";
        document.getElementById("counselor1").value = counsellorName || "";
        document.getElementById("branch1").value =
          searchParams.get("branch") || "";
      } catch (err) {
        console.error("Failed to decode base64 data:", err);
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        zone: "NA",
        leadId: "NA",
        branch: "NA",
      }));
    }

    setFormData((prev) => {
      if ((prev.academicDetails?.length || 0) === 5) return prev;
      return { ...prev, academicDetails: FIXED_EXAMS.map(EMPTY_ROW) };
    });
  }, []);

  const [showPreview, setShowPreview] = useState(false);
  // When you want to open Preview (e.g., after submit OR on a “Preview” button)
  const openPreview = () => setShowPreview(true);
  const [step, setStep] = useState(1);
  const [courses, setCourses] = useState([]);

  const makeEmptyAddr = () => ({
    line1: "",
    line2: "",
    line3: "",
    city: "",
    state: "",
    pincode: "",
    country: "India",
  });

  const [sameAsCorr, setSameAsCorr] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    dob: "",
    nationality: "",
    email: "",
    course: "",
    level: "",
    specialization: "",
    fatherName: "",
    motherName: "",
    // legacy flat strings (kept for compatibility)
    address: "",
    permanentAddress: "",
    // ✅ separate arrays
    addresses_correspondence: [makeEmptyAddr()],
    addresses_permanent: [makeEmptyAddr()],
    formHorizontalRadios: "",
    country_code: "91",
    c_number: "",
    telephone: "",
    formHorizontalRadiosMedium: "", // "Hindi" | "English"
    formHorizontalRadiosLE: "", // "Yes" | "No"
    formHorizontalRadiosSC: "", // "Sem" | "Year"
    formHorizontalRadiosCT: "", // "Full" | "Part"
    formHorizontalRadiosMS: "",
    formHorizontalRadiosPA: "",
    formHorizontalRadiosCC: "",
    workExperiences: [""],
    // studentImage: null,
    // Academic details as array of objects
    academicDetails: [
      EMPTY_ROW("10th"),
      EMPTY_ROW("12th"),
      EMPTY_ROW("Graduation"),
      EMPTY_ROW("Post Graduation"),
      EMPTY_ROW("Any Other Qualification"),
    ],

    // workExperiences: [""], // one input per experience
    counselingCenter: "",
    counselorName: "",
    payAmount: "",
    comments: "",

    branch: "",
    zone: "",
    leadId: "",
    widget_name: "ISBMU",
  });

  const handleAddrArrayChange = (arrayKey, index, field, value) => {
    setFormData((prev) => {
      const arr = [...prev[arrayKey]];
      const row = { ...arr[index], [field]: value };
      // sanitize PIN to digits if needed
      if (field === "pincode")
        row.pincode = (value || "").replace(/\D/g, "").slice(0, 10);
      arr[index] = row;
      return { ...prev, [arrayKey]: arr };
    });
  };

  const toggleSameAsCorr = (checked) => {
    setSameAsCorr(checked);
    setFormData((prev) => {
      if (!checked) return prev;
      return {
        ...prev,
        addresses_permanent: [{ ...prev.addresses_correspondence[0] }],
      };
    });
  };

  const fetchCourses = async (level) => {
    try {
      $.ajax({
        type: "GET",
        url: `https://isbmuniversity.edu.in/admin-portal/level-courses/${level}`,
        dataType: "json",
        success: (response) => setCourses(response.courses),
        error: (error) => console.error("Error fetching courses:", error),
      });
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAcademicChange = (index, e) => {
    const { name, value } = e.target;
    if (name === "examPassed") return; // lock the label

    setFormData((prev) => {
      const academicDetails = [...prev.academicDetails];
      const row = { ...academicDetails[index], [name]: value };

      if (name === "marksObtained" || name === "maxMarks") {
        const mo = parseFloat(
          name === "marksObtained" ? value : row.marksObtained,
        );
        const mm = parseFloat(name === "maxMarks" ? value : row.maxMarks);
        row.percentage =
          !isNaN(mo) && !isNaN(mm) && mm > 0
            ? ((mo / mm) * 100).toFixed(1)
            : "";
      }

      academicDetails[index] = row;
      return { ...prev, academicDetails };
    });
  };

  const addExperience = () => {
    setFormData((prev) => ({
      ...prev,
      workExperiences: [...prev.workExperiences, ""],
    }));
  };

  const removeExperience = (index) => {
    setFormData((prev) => ({
      ...prev,
      workExperiences: prev.workExperiences.filter((_, i) => i !== index),
    }));
  };

  const handleExperienceChange = (index, e) => {
    const { value } = e.target;
    setFormData((prev) => {
      const next = [...prev.workExperiences];
      next[index] = value;
      return { ...prev, workExperiences: next };
    });
  };

  const serializeWorkExperiences = (items) => {
    const labels = [
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
      "X",
    ];
    const obj = {};
    (items || [])
      .map((s) => (s ?? "").trim())
      .filter(Boolean)
      .forEach((val, idx) => {
        // if user typed "II: text", keep their Roman key
        const m = val.match(/^([IVX]+)\s*[:\)\.-]*\s*(.*)$/i);
        if (m && m[1]) {
          const key = m[1].toUpperCase();
          obj[key] = (m[2] || "").trim();
        } else {
          const key = labels[idx] || `X${idx + 1}`;
          obj[key] = val;
        }
      });
    return [obj];
  };

  const workExpSerialized = serializeWorkExperiences(formData.workExperiences);

  const isSuccessResp = (p) => {
    if (!p) return false;
    const s = String(p.success ?? p.status ?? p.result ?? "").toLowerCase();
    const msg = String(p.message ?? "").toLowerCase();

    return (
      p.success === true ||
      s === "success" ||
      s === "ok" ||
      s === "true" ||
      s === "1" ||
      p.code === 200 ||
      p.status_code === 200 ||
      msg.includes("submitted successfully") ||
      msg.includes("success")
    );
  };

  const nullify = (v) => {
    if (v == null) return null;
    if (typeof v === "string") {
      const t = v.trim();
      return t === "" ? null : t;
    }
    return v;
  };

  const cleanAcademicDetails = (rows) =>
    rows.map((r) => ({
      examPassed: r.examPassed, // keep fixed label
      stream: nullify(r.stream),
      institution: nullify(r.institution),
      yearOfPassing: r.yearOfPassing === "" ? null : Number(r.yearOfPassing),
      subjects: nullify(r.subjects),
      marksObtained: r.marksObtained === "" ? null : Number(r.marksObtained),
      maxMarks: r.maxMarks === "" ? null : Number(r.maxMarks),
      percentage:
        r.percentage === "" || isNaN(parseFloat(r.percentage))
          ? null
          : Number(parseFloat(r.percentage).toFixed(1)),
    }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.level || !String(formData.level).trim()) {
      alert("Please select Category (Level)");
      return;
    }
    if (!validateForm()) {
      alert("Please complete all required fields");
      return;
    }

    try {
      const fmtAddr = (a) =>
        [a.line1, a.line2, a.line3, a.city, a.state, a.pincode, a.country]
          .filter(Boolean)
          .join(", ");

      const corr = formData.addresses_correspondence[0];
      const perm = formData.addresses_permanent[0];

      // legacy single strings
      const legacyAddress = fmtAddr(corr);
      const legacyPermAddress = fmtAddr(perm);
      // Prepare data for submission
      const cleanedAcademic = cleanAcademicDetails(formData.academicDetails);

      const submissionData = {
        ...formData,

        // overwrite legacy text fields
        address: legacyAddress,
        permanentAddress: legacyPermAddress,

        // ✅ separate arrays in payload
        correspondenceAddress: JSON.stringify(
          formData.addresses_correspondence,
        ),
        permanentAddressArray: JSON.stringify(formData.addresses_permanent),

        academicDetails: JSON.stringify(cleanedAcademic),
        workExperience: JSON.stringify(workExpSerialized),
      };

      // Pre-fill for pay page
      const payFeesData = {
        fullName: formData.fullName || "",
        email: formData.email || "",
        telephone: formData.c_number || "",
        course: formData.course || "",
        comments: formData.comments || "",
        payAmount: formData.payAmount || "",
        counselorName: formData.counselorName || "",
      };

      sessionStorage.setItem(
        "encodedFormData",
        btoa(unescape(encodeURIComponent(JSON.stringify(payFeesData)))),
      );

      const buildFormPayload = () => {
        const fd = new FormData();

        // Add all form data
        Object.keys(submissionData).forEach((key) => {
          const val = submissionData[key];
          if (val !== null && val !== undefined) {
            if (val instanceof File || val instanceof Blob) {
              fd.append(key, val);
            } else {
              fd.append(key, String(val));
            }
          }
        });

        // if (formData.studentImage) {
        //   fd.append("studentImage", formData.studentImage);
        // }

        // Add files
        [
          "aadharCard",
          "casteCertificate",
          "tc",
          "migration",
          "tenthMarksheet",
          "twelfthMarksheet",
          "graduationMarksheet",
          "otherMarksheets",
        ].forEach((doc) => {
          if (formData[doc]) fd.append(doc, formData[doc]);
        });

        // Add category if needed
        if (submissionData.level && !fd.has("category")) {
          fd.append("category", String(submissionData.level));
        }

        return fd;
      };

      // Submit to both endpoints
      const endpoints = [
        "https://isbmuniversity.edu.in/form-api/submit-online-new.php",
        "https://insityapp.com/dbFiles/submit-application-form.php",
      ];

      const results = await Promise.allSettled(
        endpoints.map((url) =>
          fetch(url, { method: "POST", body: buildFormPayload() }),
        ),
      );

      const parsed = await Promise.all(
        results.map(async (r) => {
          if (r.status === "fulfilled") {
            try {
              return await r.value.json();
            } catch {
              return { success: false, message: "Invalid JSON" };
            }
          }
          return {
            success: false,
            message: r.reason?.message || "Network error",
          };
        }),
      );

      const anySuccess = parsed.some(isSuccessResp);
      console.log("Endpoint responses (parsed):", parsed);

      if (anySuccess) {
        // ✅ At least one endpoint succeeded: open the Offcanvas preview
        setShowPreview(true);
      } else {
        // ❌ None succeeded: show a combined error
        const msg = parsed
          .map((p, i) => `[${i + 1}] ${p?.message || "Unknown error"}`)
          .join(" | ");
        alert(`Submission failed: ${msg}`);
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const hasCorrAddr = () => {
    const a = formData.addresses_correspondence?.[0] || {};
    return a.line1 && a.city && a.state && a.pincode && a.country;
  };

  const validateForm = () => {
    return (
      formData.level &&
      formData.course &&
      formData.email &&
      (formData.c_number || formData.telephone) && // prefer mobile; keep landline fallback if you like
      formData.fullName &&
      formData.fatherName &&
      formData.formHorizontalRadios && // gender
      formData.formHorizontalRadiosMedium && // medium
      formData.formHorizontalRadiosLE && // lateral entry
      formData.formHorizontalRadiosSC && // scheme
      formData.formHorizontalRadiosCT && // course type
      formData.counselingCenter &&
      formData.counselorName &&
      formData.payAmount &&
      hasCorrAddr()
    );
  };

  const nextStep = () => {
    if (validateCurrentStep()) {
      setStep(step + 1);
    } else {
      alert("Please complete all required fields before proceeding");
    }
  };

  const prevStep = () => setStep(step - 1);

  const validateCurrentStep = () => {
    switch (step) {
      case 1:
        return (
          formData.level &&
          formData.email &&
          formData.course &&
          formData.telephone &&
          formData.fullName &&
          formData.fatherName &&
          formData.formHorizontalRadios
        );
      case 2:
        return true; // Optional academic
      case 3:
        return (
          formData.counselingCenter &&
          formData.counselorName &&
          formData.payAmount
        );
      default:
        return true;
    }
  };

  const handleFileChange = (index, e) => {
    const file = e.target.files[0];
    setFormData((prev) => {
      const updated = { ...prev };
      updated.academicDetails[index].marksheet = file;
      return updated;
    });
  };

  return (
    <>
      <title>
        Apply Online - Admissions Open Now | ISBM University Chattisgrah
      </title>
      <meta
        name="description"
        content="Apply online for admission to ISBM University for UG, PG, diploma and Ph.D. programmes in Chhattisgarh. Submit your application today as seats are filling fast."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Apply Online</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Apply Online
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-50">
        <div className="container-xxl">
          <div className="row justify-content-center">
            <div className="px-lg-5">
              <h2 className="section-title modern-title text-center text-blue">
                Admission Procedure Guidelines
              </h2>
              <p className="modern-subtitle text-center text-blue">
                ISBM University has multiple options available for efficient and
                secure fee payment for students. Details regarding the different
                modes of fee payment for students are given below.
              </p>
              <div className="row g-4">
                <div className="col-lg-6">
                  <div className="card p-2 border-0 shadow h-100">
                    <div className="card-header bg-white border-0 pb-0">
                      <h3 className="fw-semibold mb-3">
                        Admission Requirements
                      </h3>
                    </div>
                    <div className="card-body pt-1">
                      <ul className="list-unstyled mb-0">
                        <li className="py-3 d-flex align-items-center border-bottom border-light-root">
                          <div className="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                            <i className="ti ti-check fs-5"></i>
                          </div>
                          <span>
                            Photo Copies of Mark Sheets & Certificates
                          </span>
                        </li>
                        <li className="py-3 d-flex align-items-center border-bottom border-light-root">
                          <div className="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                            <i className="ti ti-check fs-5"></i>
                          </div>
                          <span>Four Latest Photographs</span>
                        </li>
                        <li className="py-3 d-flex align-items-center border-bottom border-light-root">
                          <div className="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                            <i className="ti ti-check fs-5"></i>
                          </div>
                          <span>Identity Proof</span>
                        </li>
                        <li className="py-3 d-flex align-items-center border-bottom border-light-root">
                          <div className="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                            <i className="ti ti-check fs-5"></i>
                          </div>
                          <span>Address Proof</span>
                        </li>
                        <li className="py-3 d-flex align-items-center">
                          <div className="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                            <i className="ti ti-check fs-5"></i>
                          </div>
                          <span>Work Experience Certificate if any</span>
                        </li>
                      </ul>
                    </div>
                    <div className="card-footer bg-white border-0 pt-0">
                      <div className="alert alert-light-blue border border-light-root mb-2">
                        <div className="d-flex">
                          <i className="ti ti-info-circle text-blue me-2 mt-1"></i>
                          <div>
                            <p className="mb-2">
                              <strong>Note:</strong> All documents must be
                              attested.
                            </p>
                            <p className="mb-0">
                              <strong>Eligibility:</strong> Please refer the
                              list of Courses for details.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="card p-2 border-0 shadow h-100">
                    <div className="card-header bg-white border-0 pb-0">
                      <h3 className="fw-semibold mb-3">
                        Application Procedure
                      </h3>
                    </div>
                    <div className="card-body pt-1">
                      <div className="v-steps">
                        <div className="step-item guidelines py-3">
                          <div className="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">
                            1
                          </div>
                          <div className="step-content">
                            <p className="mb-1">
                              Download the official application form from the
                              university website in printable format.
                            </p>
                            <a
                              href={Admissionform}
                              className="d-inline-flex align-items-center text-blue fw-semibold text-decoration-none"
                              download
                            >
                              Download admission form
                              <i className="ti ti-chevron-right ms-1 fs-xs"></i>
                            </a>
                          </div>
                        </div>
                        <div className="step-item guidelines py-3 border-bottom border-light-root">
                          <div className="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">
                            2
                          </div>
                          <div className="step-content">
                            <p className="mb-1">
                              Fill out the form accurately and submit it either
                              in person or post it to ISBM University's
                              admission office.
                            </p>
                          </div>
                        </div>
                        <div className="step-item guidelines py-3 border-bottom border-light-root ">
                          <div className="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">
                            3
                          </div>
                          <div className="step-content">
                            <p className="mb-1">
                              Make the fee payment using any of the available
                              payment options listed on our website.
                            </p>
                            <a
                              href="/pay-fees-online"
                              className="d-inline-flex align-items-center text-blue fw-semibold text-decoration-none"
                            >
                              View payment options
                              <i className="ti ti-chevron-right ms-1 fs-xs"></i>
                            </a>
                          </div>
                        </div>
                        <div className="step-item guidelines py-3">
                          <div className="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">
                            4
                          </div>
                          <div className="step-content">
                            <p className="mb-1">
                              Ensure to carry all relevant academic and identity
                              documents during verification or physical
                              submission.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-light p-4 rounded-3 mt-5 mb-3 border-start border-4 border-purple">
                <p className="mb-2">
                  <b>
                    Application Form is available at the Admission Cell, ISBM
                    University, Chhura, Gariyaband, Chattisgarh on cash payment
                    of 900 INR.
                  </b>
                </p>
                <div className="divider my-3">
                  <span className="px-2 bg-white text-dark fw-bold">OR</span>
                </div>
                <p className="mb-0">
                  <b>
                    Application form can be downloaded from website and sent
                    along with a DD of 900 INR in favor of 'ISBM University',
                    payable at Raipur and required to be sent at the address
                    given below:
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-50 bg-light-blue">
        <div className="container-xxl">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <Form onSubmit={handleSubmit} method="post">
                <div className="form-wizard-container">
                  <div className="form-wizard-header text-center mb-5">
                    <h2 className="form-title text-blue">
                      Online Application Form
                    </h2>
                    <p className="form-subtitle">
                      Complete your application in 3 simple steps
                    </p>
                  </div>

                  {/* Progress Bar */}
                  <div className="form-progress">
                    <div
                      className={`progress-step ${step >= 1 ? "active" : ""}`}
                    >
                      <div className="step-number">1</div>
                      <div className="step-label">Student Details</div>
                    </div>
                    <div
                      className={`progress-step ${step >= 2 ? "active" : ""}`}
                    >
                      <div className="step-number">2</div>
                      <div className="step-label">Academic Details</div>
                    </div>
                    <div
                      className={`progress-step ${step >= 3 ? "active" : ""}`}
                    >
                      <div className="step-number">3</div>
                      <div className="step-label">Admission Details</div>
                    </div>
                    <div
                      className={`progress-step ${step >= 4 ? "active" : ""}`}
                    >
                      <div className="step-number">4</div>
                      <div className="step-label">Other Documents</div>
                    </div>
                  </div>

                  {/* Step 1: Student Details */}
                  {step === 1 && (
                    <div className="form-step active">
                      <div className="form-card">
                        <h3 className="step-title">
                          Student Imperative Details
                        </h3>
                        <p className="step-description">
                          This page is an electronic version of the application
                          form. Filling and submitting this form will navigate
                          to an online payment process/page. If you don't wish
                          to do an online payment, you are requested to download
                          the form, fill it and send it to your nearest ISBM
                          University center.
                        </p>

                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Category*</Form.Label>
                              <Form.Select
                                required
                                name="level"
                                value={formData.level}
                                onChange={(e) => {
                                  handleChange(e);
                                  fetchCourses(e.target.value);
                                }}
                              >
                                <option value="">Select Level</option>
                                <option value="Doctorate">Doctorate</option>
                                <option value="Postgraduate">
                                  Post Graduate
                                </option>
                                <option value="Undergraduate">
                                  Under Graduate
                                </option>
                                <option value="Post Graduate Diploma">
                                  Post Graduate Diploma
                                </option>
                                <option value="Diploma">Diploma</option>
                                <option value="Certificate">Certificate</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Course*</Form.Label>
                              <Form.Select
                                name="course"
                                value={formData.course}
                                onChange={handleChange}
                                required
                              >
                                <option value="">...Select Course...</option>
                                {courses.map((course) => (
                                  <option key={course.id} value={course.title}>
                                    {course.title}
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label>Specialization</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Full name"
                                name="specialization"
                                value={formData.specialization}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <fieldset className="mb-3">
                              <Form.Label>Medium of Instruction*</Form.Label>
                              <div className="medium">
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Hindi"
                                  name="formHorizontalRadiosMedium"
                                  id="formHorizontalRadiosMediumHindi"
                                  value="mid_hindi"
                                  checked={
                                    formData.formHorizontalRadiosMedium ===
                                    "mid_hindi"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="English"
                                  name="formHorizontalRadiosMedium"
                                  id="formHorizontalRadiosMediumEnglish"
                                  value="mid_english"
                                  checked={
                                    formData.formHorizontalRadiosMedium ===
                                    "mid_english"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </fieldset>
                          </Col>
                          <Col md={3}>
                            <fieldset className="mb-3">
                              <Form.Label>Lateral Entry*</Form.Label>
                              <div className="lateral-entry">
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Yes"
                                  name="formHorizontalRadiosLE"
                                  id="formHorizontalRadiosLEYes"
                                  value="yes"
                                  checked={
                                    formData.formHorizontalRadiosLE === "yes"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="No"
                                  name="formHorizontalRadiosLE"
                                  id="formHorizontalRadiosLENo"
                                  value="no"
                                  checked={
                                    formData.formHorizontalRadiosLE === "no"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </fieldset>
                          </Col>
                          <Col md={3}>
                            <fieldset className="mb-3">
                              <Form.Label>Study Scheme*</Form.Label>
                              <div className="study-scheme">
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Sem"
                                  name="formHorizontalRadiosSC"
                                  id="formHorizontalRadiosSCSemMode"
                                  value="sem-mode"
                                  checked={
                                    formData.formHorizontalRadiosSC ===
                                    "sem-mode"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Year"
                                  name="formHorizontalRadiosSC"
                                  id="formHorizontalRadiosSCYearMode"
                                  value="year-mode"
                                  checked={
                                    formData.formHorizontalRadiosSC ===
                                    "year-mode"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </fieldset>
                          </Col>
                          <Col md={3}>
                            <fieldset className="mb-3">
                              <Form.Label>Course Type*</Form.Label>
                              <div className="course-type">
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Full Time"
                                  name="formHorizontalRadiosCT"
                                  id="formHorizontalRadiosCTFullTime"
                                  value="full-time"
                                  checked={
                                    formData.formHorizontalRadiosCT ===
                                    "full-time"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Part Time"
                                  name="formHorizontalRadiosCT"
                                  id="formHorizontalRadiosCTPartTime"
                                  value="part-time"
                                  checked={
                                    formData.formHorizontalRadiosCT ===
                                    "part-time"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </fieldset>
                          </Col>
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label>
                                Full Name *(In block Letters)
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Full name"
                                name="fullName"
                                value={formData.fullName}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label>
                                Father's Name *(In block Letters)
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Father's name"
                                name="fatherName"
                                value={formData.fatherName}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label>
                                Mother's Name *(In block Letters)
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Mother's name"
                                name="motherName"
                                value={formData.motherName}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          {/* 9. PERMANENT ADDRESS (if different...) */}
                          <Col md={12} className="mb-4">
                            <div className="addr-box border p-3 rounded">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <div className="fw-bold">
                                  9. PERMANENT ADDRESS{" "}
                                  <span className="text-muted">
                                    (if different from correspondence address)
                                  </span>
                                </div>
                                <Form.Check
                                  type="switch"
                                  id="sameAsCorr"
                                  label="Same as correspondence"
                                  checked={sameAsCorr}
                                  onChange={(e) =>
                                    toggleSameAsCorr(e.target.checked)
                                  }
                                />
                              </div>

                              <div className="small mb-1">Address:</div>
                              <Form.Control
                                className="addr-underline"
                                type="text"
                                placeholder="Line 1"
                                value={formData.addresses_permanent[0].line1}
                                onChange={(e) =>
                                  handleAddrArrayChange(
                                    "addresses_permanent",
                                    0,
                                    "line1",
                                    e.target.value,
                                  )
                                }
                              />
                              <Form.Control
                                className="addr-underline mt-2"
                                type="text"
                                placeholder="Line 2"
                                value={formData.addresses_permanent[0].line2}
                                onChange={(e) =>
                                  handleAddrArrayChange(
                                    "addresses_permanent",
                                    0,
                                    "line2",
                                    e.target.value,
                                  )
                                }
                              />
                              <Form.Control
                                className="addr-underline mt-2"
                                type="text"
                                placeholder="Line 3 / Area"
                                value={formData.addresses_permanent[0].line3}
                                onChange={(e) =>
                                  handleAddrArrayChange(
                                    "addresses_permanent",
                                    0,
                                    "line3",
                                    e.target.value,
                                  )
                                }
                              />

                              <Row className="mt-2">
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">State:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      placeholder="Maharashtra"
                                      value={
                                        formData.addresses_permanent[0].state
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_permanent",
                                          0,
                                          "state",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">City:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      placeholder="Navi Mumbai"
                                      value={
                                        formData.addresses_permanent[0].city
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_permanent",
                                          0,
                                          "city",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mt-2">
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">PIN / ZIP Code:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      inputMode="numeric"
                                      placeholder="400706"
                                      value={
                                        formData.addresses_permanent[0].pincode
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_permanent",
                                          0,
                                          "pincode",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">Country:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      placeholder="India"
                                      value={
                                        formData.addresses_permanent[0].country
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_permanent",
                                          0,
                                          "country",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          {/* 10. CORRESPONDENCE ADDRESS */}
                          <Col md={12} className="mb-4">
                            <div className="addr-box border p-3 rounded">
                              <div className="fw-bold mb-2">
                                10. CORRESPONDENCE ADDRESS
                              </div>

                              <div className="small mb-1">Address:</div>
                              <Form.Control
                                className="addr-underline"
                                type="text"
                                placeholder="Line 1"
                                value={
                                  formData.addresses_correspondence[0].line1
                                }
                                onChange={(e) =>
                                  handleAddrArrayChange(
                                    "addresses_correspondence",
                                    0,
                                    "line1",
                                    e.target.value,
                                  )
                                }
                                required
                              />
                              <Form.Control
                                className="addr-underline mt-2"
                                type="text"
                                placeholder="Line 2"
                                value={
                                  formData.addresses_correspondence[0].line2
                                }
                                onChange={(e) =>
                                  handleAddrArrayChange(
                                    "addresses_correspondence",
                                    0,
                                    "line2",
                                    e.target.value,
                                  )
                                }
                              />
                              <Form.Control
                                className="addr-underline mt-2"
                                type="text"
                                placeholder="Line 3 / Area"
                                value={
                                  formData.addresses_correspondence[0].line3
                                }
                                onChange={(e) =>
                                  handleAddrArrayChange(
                                    "addresses_correspondence",
                                    0,
                                    "line3",
                                    e.target.value,
                                  )
                                }
                              />

                              <Row className="mt-2">
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">State:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      placeholder="Maharashtra"
                                      value={
                                        formData.addresses_correspondence[0]
                                          .state
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_correspondence",
                                          0,
                                          "state",
                                          e.target.value,
                                        )
                                      }
                                      required
                                    />
                                  </div>
                                </Col>
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">City:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      placeholder="Navi Mumbai"
                                      value={
                                        formData.addresses_correspondence[0]
                                          .city
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_correspondence",
                                          0,
                                          "city",
                                          e.target.value,
                                        )
                                      }
                                      required
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mt-2">
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">PIN / ZIP Code:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      inputMode="numeric"
                                      placeholder="400706"
                                      value={
                                        formData.addresses_correspondence[0]
                                          .pincode
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_correspondence",
                                          0,
                                          "pincode",
                                          e.target.value,
                                        )
                                      }
                                      required
                                    />
                                  </div>
                                </Col>
                                <Col xs={6}>
                                  <div className="d-flex align-items-center gap-2">
                                    <div className="small">Country:</div>
                                    <Form.Control
                                      className="addr-underline"
                                      type="text"
                                      placeholder="India"
                                      value={
                                        formData.addresses_correspondence[0]
                                          .country
                                      }
                                      onChange={(e) =>
                                        handleAddrArrayChange(
                                          "addresses_correspondence",
                                          0,
                                          "country",
                                          e.target.value,
                                        )
                                      }
                                      required
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col md={3}>
                            <Form.Group className="mb-3">
                              <Form.Label>Date of birth</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Date of birth"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className="mb-3">
                              <Form.Label>Nationality*</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Nationality"
                                name="nationality"
                                value={formData.nationality}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <fieldset className="mb-3">
                              <Form.Label>Gender*</Form.Label>
                              <div className="gender-options">
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Female"
                                  name="formHorizontalRadios"
                                  id="formHorizontalRadiosFemale"
                                  value="female"
                                  checked={
                                    formData.formHorizontalRadios === "female"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Male"
                                  name="formHorizontalRadios"
                                  id="formHorizontalRadiosMale"
                                  value="male"
                                  checked={
                                    formData.formHorizontalRadios === "male"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </fieldset>
                          </Col>
                          <Col md={3}>
                            <fieldset className="mb-3">
                              <Form.Label>Marital Status*</Form.Label>
                              <div className="marital-status">
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Single"
                                  name="formHorizontalRadiosMS"
                                  id="formHorizontalRadiosMSsingle"
                                  value="single"
                                  checked={
                                    formData.formHorizontalRadiosMS === "single"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Married"
                                  name="formHorizontalRadiosMS"
                                  id="formHorizontalRadiosMSmarried"
                                  value="married"
                                  checked={
                                    formData.formHorizontalRadiosMS ===
                                    "married"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </fieldset>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Contact Number*</Form.Label>

                              <div className="d-flex gap-3">
                                <div className="flex-fill">
                                  <div className="small text-muted fw-semibold mb-1">
                                    Country Code
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <span className="me-2">+</span>
                                    <Form.Control
                                      type="tel"
                                      inputMode="numeric"
                                      pattern="[0-9]*"
                                      placeholder="91"
                                      name="country_code"
                                      value={formData.country_code ?? ""}
                                      onChange={(e) => {
                                        const v = e.target.value
                                          .replace(/\D/g, "")
                                          .slice(0, 3); // keep digits, max 3
                                        handleChange({
                                          target: {
                                            name: "country_code",
                                            value: v,
                                          },
                                        });
                                      }}
                                      className="phone-underline cc-input"
                                    />
                                  </div>
                                </div>

                                <div className="flex-fill">
                                  <div className="small text-muted fw-semibold mb-1">
                                    Mobile Number
                                  </div>

                                  <Form.Control
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={10}
                                    pattern="[0-9]*"
                                    placeholder="9876543210"
                                    name="c_number"
                                    value={formData.c_number}
                                    onChange={(e) => {
                                      const v = e.target.value
                                        .replace(/\D/g, "") // remove non-digits
                                        .slice(0, 10); // limit to 10 digits

                                      handleChange({
                                        target: {
                                          name: "c_number",
                                          value: v,
                                        },
                                      });
                                    }}
                                    className="phone-underline"
                                  />
                                </div>
                              </div>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Landline</Form.Label>

                              <div className="small text-muted fw-semibold mb-1">
                                Landline phone number with STD (area) code
                              </div>

                              <Form.Control
                                type="text"
                                inputMode="numeric"
                                maxLength={15}
                                placeholder="Landline"
                                name="telephone"
                                value={formData.telephone}
                                onChange={(e) => {
                                  const v = e.target.value
                                    .replace(/\D/g, "") // remove non-numbers
                                    .slice(0, 15); // max 15 digits

                                  handleChange({
                                    target: {
                                      name: "telephone",
                                      value: v,
                                    },
                                  });
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Email*</Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <fieldset className="mb-3">
                              <Form.Label>Category*</Form.Label>
                              <div className="category">
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="GEN"
                                  name="formHorizontalRadiosCC"
                                  id="formHorizontalRadiosCCGEN"
                                  value="GEN"
                                  checked={
                                    formData.formHorizontalRadiosCC === "GEN"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="SC"
                                  name="formHorizontalRadiosCC"
                                  id="formHorizontalRadiosCCSC"
                                  value="SC"
                                  checked={
                                    formData.formHorizontalRadiosCC === "SC"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="Minority"
                                  name="formHorizontalRadiosCC"
                                  id="formHorizontalRadiosCCMinority"
                                  value="Minority"
                                  checked={
                                    formData.formHorizontalRadiosCC ===
                                    "Minority"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="OBC"
                                  name="formHorizontalRadiosCC"
                                  id="formHorizontalRadiosCCOBC"
                                  value="OBC"
                                  checked={
                                    formData.formHorizontalRadiosCC === "OBC"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                                <Form.Check
                                  inline
                                  className="gender-selection"
                                  type="radio"
                                  label="ST"
                                  name="formHorizontalRadiosCC"
                                  id="formHorizontalRadiosCCST"
                                  value="ST"
                                  checked={
                                    formData.formHorizontalRadiosCC === "ST"
                                  }
                                  onChange={handleChange}
                                  required
                                />
                              </div>
                            </fieldset>
                          </Col>
                          {/* <Col md={4}>
                            {" "}
                            <Form.Group className="mb-3">
                              <Form.Label>Student Image</Form.Label>
                              <Form.Control
                                type="file"
                                accept="image/*" // only allow image formats (jpg, png, etc.)
                                name="studentImage"
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    studentImage: e.target.files[0], // store uploaded image file
                                  })
                                }
                              />
                            </Form.Group>
                          </Col> */}
                        </Row>
                      </div>

                      <div className="form-actions">
                        <button
                          type="button"
                          className="btn btn-next btn-outline-blue"
                          onClick={nextStep}
                        >
                          Next: Academic Details
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Step 2: Academic Details */}
                  {step === 2 && (
                    <div className="form-step active">
                      <div className="form-card">
                        <div className="row">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h3 className="step-title">
                              Academic & Work Experience Details
                            </h3>
                            {/* <Button
                              variant="btn btn-next"
                              onClick={addAcademicDetail}
                            >
                              + Add More Academic Details
                            </Button> */}
                          </div>
                        </div>
                        <p className="step-description">
                          Examination taken (Please list in chronological order
                          including examinations with results pending)
                        </p>

                        <div className="acad-stack">
                          {formData.academicDetails.map((row, index) => (
                            <div className="acad-card" key={row.examPassed}>
                              <div className="acad-head">
                                <span className="acad-title">
                                  {row.examPassed}
                                </span>
                              </div>

                              <Row className="g-3">
                                <Col md={6}>
                                  <Form.Group>
                                    <Form.Label>Stream</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="stream"
                                      value={row.stream}
                                      onChange={(e) =>
                                        handleAcademicChange(index, e)
                                      }
                                      placeholder="Commerce / Science / —"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col md={6}>
                                  <Form.Group>
                                    <Form.Label>Year of passing</Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="yearOfPassing"
                                      value={row.yearOfPassing}
                                      onChange={(e) =>
                                        handleAcademicChange(index, e)
                                      }
                                      placeholder="2023"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col md={12}>
                                  <Form.Group>
                                    <Form.Label>
                                      Name of the School / college and Board /
                                      University
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="institution"
                                      value={row.institution}
                                      onChange={(e) =>
                                        handleAcademicChange(index, e)
                                      }
                                      placeholder="ABC High School, CBSE"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col md={12}>
                                  <Form.Group>
                                    <Form.Label>Subject Studies</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="subjects"
                                      value={row.subjects}
                                      onChange={(e) =>
                                        handleAcademicChange(index, e)
                                      }
                                      placeholder="English, Maths, Science"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col md={4}>
                                  <Form.Group>
                                    <Form.Label>Marks Obtained</Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="marksObtained"
                                      value={row.marksObtained}
                                      onChange={(e) =>
                                        handleAcademicChange(index, e)
                                      }
                                      placeholder="445"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col md={4}>
                                  <Form.Group>
                                    <Form.Label>Maximum Marks</Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="maxMarks"
                                      value={row.maxMarks}
                                      onChange={(e) =>
                                        handleAcademicChange(index, e)
                                      }
                                      placeholder="500"
                                    />
                                  </Form.Group>
                                </Col>

                                <Col md={4}>
                                  <Form.Group>
                                    <Form.Label>% of Marks</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="percentage"
                                      value={row.percentage}
                                      onChange={(e) =>
                                        handleAcademicChange(index, e)
                                      } // allow manual override
                                      placeholder="89"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </div>
                          ))}
                        </div>

                        <div className="d-flex justify-content-between align-items-center m-3">
                          <h3 className="step-title">
                            Work Experience Details
                          </h3>
                          <Button
                            variant="btn btn-next"
                            onClick={addExperience}
                          >
                            + Add Work Experience
                          </Button>
                        </div>

                        {formData.workExperiences.map((exp, index) => (
                          <div
                            className="form-card border p-3 mb-3"
                            key={index}
                          >
                            <Row>
                              <Col md={12}>
                                <Form.Group className="mb-2">
                                  <Form.Label>
                                    Experience {index + 1}
                                  </Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder={`Example: Company – Role (Jan 2022 – Dec 2024)\nOr prefix with Roman: ${
                                      index === 0 ? "I" : "II"
                                    }: Company – Role ...`}
                                    value={exp}
                                    onChange={(e) =>
                                      handleExperienceChange(index, e)
                                    }
                                  />
                                  <Form.Text muted>
                                    You can prefix with <b>I:</b>, <b>II:</b>,{" "}
                                    <b>III:</b> to lock the numbering; otherwise
                                    we’ll number automatically.
                                  </Form.Text>
                                </Form.Group>
                              </Col>

                              <Col md={12} className="text-end">
                                {formData.workExperiences.length > 1 && (
                                  <Button
                                    variant="danger"
                                    onClick={() => removeExperience(index)}
                                  >
                                    Remove
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </div>
                        ))}

                        <Col md={6}>
                          <fieldset className="mb-3">
                            <Form.Label>Provisionally Admitted*</Form.Label>
                            <div className="PA">
                              <Form.Check
                                inline
                                className="gender-selection"
                                type="radio"
                                label="Yes"
                                name="formHorizontalRadiosPA"
                                id="formHorizontalRadiosPAYes"
                                value="yes"
                                checked={
                                  formData.formHorizontalRadiosPA === "yes"
                                }
                                onChange={handleChange}
                                required
                              />
                              <Form.Check
                                inline
                                className="gender-selection"
                                type="radio"
                                label="No"
                                name="formHorizontalRadiosPA"
                                id="formHorizontalRadiosPANo"
                                value="no"
                                checked={
                                  formData.formHorizontalRadiosPA === "no"
                                }
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </fieldset>
                        </Col>
                      </div>

                      <div className="form-actions mt-4">
                        <button
                          type="button"
                          className="btn btn-prev"
                          onClick={prevStep}
                        >
                          Previous
                        </button>
                        <button
                          type="button"
                          className="btn btn-next"
                          onClick={nextStep}
                        >
                          Next: Admission Details
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Step 3: Admission Details */}
                  {step === 3 && (
                    <div className="form-step active">
                      <div className="form-card">
                        <h3 className="step-title">Admission Details</h3>

                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Counselling Centre*</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Counselling Centre"
                                name="counselingCenter"
                                value={formData.counselingCenter}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Counselor Name*</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Counselor Name"
                                name="counselorName"
                                value={formData.counselorName}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6} className="d-none">
                            <Form.Group className="mb-3">
                              <Form.Label>Zone</Form.Label>
                              <Form.Control
                                type="text"
                                name="zone"
                                value={formData.zone}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6} className="d-none">
                            <Form.Group className="mb-3">
                              <Form.Label>branch</Form.Label>
                              <Form.Control
                                type="text"
                                name="branch"
                                value={formData.branch}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6} className="d-none">
                            <Form.Group className="mb-3">
                              <Form.Label>Entity</Form.Label>
                              <Form.Control
                                type="text"
                                name="widget_name"
                                value="ISBMU"
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6} className="d-none">
                            <Form.Group className="mb-3">
                              <Form.Label>Lead Id</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Counselor Name"
                                name="leadId"
                                value={formData.leadId}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Pay Amount*</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Pay Amount"
                                name="payAmount"
                                value={formData.payAmount}
                                onChange={handleChange}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Form.Group className="mb-3">
                          <Form.Label>Comments</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                          />
                        </Form.Group>
                      </div>
                      <div className="form-actions mt-4">
                        <button
                          type="button"
                          className="btn btn-prev"
                          onClick={prevStep}
                        >
                          Previous
                        </button>
                        <button
                          type="button"
                          className="btn btn-next"
                          onClick={nextStep}
                        >
                          Next: Other Documents
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Step 4: Other Documents Upload */}
                  {step === 4 && (
                    <div className="form-step active">
                      <div className="form-card">
                        <h3 className="step-title">Upload Other Documents</h3>
                        <p>
                          Please upload the following documents (PDF / Image):
                        </p>

                        {[
                          "aadharCard",
                          "casteCertificate",
                          "tc",
                          "migration",
                        ].map((doc) => (
                          <Form.Group className="mb-3" key={doc}>
                            <Form.Label>
                              {doc === "aadharCard"
                                ? "Aadhar Card"
                                : doc === "casteCertificate"
                                  ? "Caste Certificate"
                                  : doc === "tc"
                                    ? "Transfer Certificate (TC)"
                                    : "Migration Certificate"}
                            </Form.Label>
                            <Form.Control
                              type="file"
                              name={doc}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  [doc]: e.target.files[0],
                                })
                              }
                            />
                          </Form.Group>
                        ))}

                        {/* New marksheet uploads */}
                        {[
                          "tenthMarksheet",
                          "twelfthMarksheet",
                          "graduationMarksheet",
                          "otherMarksheets",
                        ].map((doc) => (
                          <Form.Group className="mb-3" key={doc}>
                            <Form.Label>
                              {doc === "tenthMarksheet"
                                ? "10th Marksheet"
                                : doc === "twelfthMarksheet"
                                  ? "12th Marksheet"
                                  : doc === "graduationMarksheet"
                                    ? "Graduation Marksheet"
                                    : "Other Marksheets"}
                            </Form.Label>
                            <Form.Control
                              type="file"
                              name={doc}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  [doc]: e.target.files[0],
                                })
                              }
                            />
                          </Form.Group>
                        ))}
                      </div>

                      <div className="declaration mt-4">
                        <h6>Declaration by the Candidate</h6>
                        <p>
                          I certify that all information provided in this
                          application proforma is complete and accurate. I agree
                          to familiarize myself with all the rules and
                          regulations of the programme set forth by ISBM
                          University and abide by them. I would uplift the
                          standards and respect the principles of ISBM
                          University as an organization of higher learning.
                        </p>
                        <Form.Check
                          type="checkbox"
                          label="I agree to the terms and conditions*"
                          required
                        />
                      </div>

                      <div className="form-actions mt-4">
                        <button
                          type="button"
                          className="btn btn-prev"
                          onClick={() => setStep(3)}
                        >
                          Previous
                        </button>
                        <button type="submit" className="btn btn-submit">
                          Submit Application
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-50">
        <div className="container-xxl">
          <div className="row justify-content-center">
            <div className="px-lg-5">
              <h5 className="card-title fs-3 fw-bold section-title-start text-blue mb-4">
                <i className="ti ti-info-alt me-2"></i> University Contact
                Details
              </h5>

              <div className="row g-4">
                {/* Gariyaband Address */}
                <div className="col-md-6 col-lg-6">
                  <div className="border-0 shadow bg-primary-soft p-4 h-100 rounded-3">
                    <div className="d-flex align-items-center mb-3">
                      <div className="p-2 bg-blue text-white rounded-circle me-3">
                        <i className="fs-4 ti ti-location-pin"></i>
                      </div>
                      <h6 className="fw-bold mb-0 text-blue">
                        ISBM University Campus
                      </h6>
                    </div>
                    <p className="mb-0">
                      ISBM University: Village Nawapara (Kosmi), Block Chhura,
                      District Gariyaband, Chhattisgarh - 493996
                    </p>
                  </div>
                </div>

                {/* Raipur Address */}
                <div className="col-md-6 col-lg-6">
                  <div className="border-0 shadow bg-primary-soft p-4 h-100 rounded-3">
                    <div className="d-flex align-items-center mb-3">
                      <div className="p-2 bg-blue text-white rounded-circle me-3">
                        <i className="fs-4 ti ti-map-pin"></i>
                      </div>
                      <h6 className="fw-bold mb-0 text-blue">
                        ISBM University Raipur Campus
                      </h6>
                    </div>
                    <p className="mb-0">
                      ISBM University, Dumar Talab, Near Old Amanaka Thana, Next
                      To Kanger Valley Academy, Raipur 492099
                    </p>
                  </div>
                </div>

                {/* Contact Details */}
                <div className="col-md-6 col-lg-6">
                  <div className="border-0 shadow bg-primary-soft p-4 h-100 rounded-3">
                    <div className="d-flex align-items-center mb-3">
                      <div className="p-2 bg-blue text-white rounded-circle me-3">
                        <i className="fs-4 ti ti-phone"></i>
                      </div>
                      <h6 className="fw-bold mb-0 text-blue">Contact</h6>
                    </div>
                    <p className="mb-0">+91 9373199999</p>
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-6 col-lg-6">
                  <div className="border-0 shadow bg-primary-soft p-4 h-100 rounded-3">
                    <div className="d-flex align-items-center mb-3">
                      <div className="p-2 bg-blue text-white rounded-circle me-3">
                        <i className="fs-4 ti ti-mail"></i>
                      </div>
                      <h6 className="fw-bold mb-0 text-blue">Email</h6>
                    </div>
                    <p className="mb-0">info@isbmuniversity.edu.in</p>
                  </div>
                </div>
              </div>

              {/* Download Button */}
              <div className="d-flex flex-column flex-md-row gap-3 justify-content-center mt-5">
                <a
                  href={Admissionform}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-purple btn-lg px-4 py-3 d-flex align-items-center justify-content-center"
                >
                  <i className="ti ti-download me-2 fs-5"></i> Download
                  Admission Form
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ApplicationPdfModal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        data={{
          ...formData,
          // keep arrays as-is for the preview
          academicDetails: formData.academicDetails,
          workExperiences: formData.workExperiences,
          // keep “old shape” too so the component can parse either
          workExperience: JSON.stringify(
            serializeWorkExperiences(formData.workExperiences),
          ),
        }}
        onProceed={() => {
          // you already saved sessionStorage payload in handleSubmit
          setShowPreview(false);
          window.location.href = "/pay-fees-online";
        }}
      />
      <Footer />
    </>
  );
};

export default ApplyOnline;
